'use client';

import { useCJTracking } from './use-cj';
import { useFacebookTracking } from './use-facebook';
import { useMailchimpTracking } from './use-mailchimp';

export const SearchParamsRecorder = () => {
  useMailchimpTracking();
  useFacebookTracking();
  useCJTracking();

  return null;
};
